<template>
    <div class="grid">
        <div class="image-and-header">
            <div class="image">
                <ResultsPractitionerImage :result="result" />
            </div>
            <div class="header">
                <ResultsPractitionerHeader  :result="result" :rank="rank" />
            </div>
        </div>
        <div>
            <ResultsNetworkBannerContainer :result="result" :rank="rank"/>
            <ResultsPractitionerInfo :result="result" :rank="rank"/>
        </div>
    </div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const toggle = ref(false)

</script>

<style scoped lang="scss">

    .image-and-header {
        display: grid;
        grid-template-columns: auto 11fr;
        column-gap: var(--spacing-xs);

        .header {
            align-self: center;
        }
    }

</style>